import { ExaminationCourseHeader } from '@exam-management/examination-course-details';
import {
  PermissionRouteGuard,
  type PermissionRouteGuardData,
} from '@exam-management/permission-route-guard';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useParams } from '@exam-management/router';
import { Outlet } from 'react-router-dom';

export default function ExamCourseListLayout() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfigs');
  const defaultRoutes: PermissionRouteGuardData[] = [
    {
      path: '/exam-courses/:courseId/qconfigs',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: { courseId },
    },
    {
      path: '/exam-courses/:courseId/qconfig-generators',
      requiredPermission: [APP_PERMISSIONS.EXAM.QCONFIG.VIEW],
      params: { courseId },
    },
    {
      path: '/exam-courses/:courseId/qsets',
      requiredPermission: [APP_PERMISSIONS.EXAM.QSET.VIEW],
      params: { courseId },
    },
  ];

  return (
    <PermissionRouteGuard routes={defaultRoutes}>
      <ExaminationCourseHeader />
      <Outlet />
    </PermissionRouteGuard>
  );
}
